var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(_vm.message)+" "),(_vm.months)?_c('a',{on:{"click":_vm.widen}},[_vm._v("Suche erweitern")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }